module.exports = __webpack_public_path__ + "img/ss-speaker.1de68925.svg";